<form [formGroup]="form">
  <gcc-radio-group name="id" formControlName="selected">
    @for (option of options; track option; let i = $index) {
      <div>
        <gcc-radio-button [id]="option.id" [value]="option.id">{{ option.text }}</gcc-radio-button>
      </div>
    }
    <gcc-radio-button [id]="-1" [value]="-1">Other</gcc-radio-button>
  </gcc-radio-group>
</form>
